// @ts-nocheck

import * as Types from '../../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type CreateCustomObjectMutationVariables = Types.Exact<{
  model: Types.CustomObjectCreationModelInput;
}>;

export type CreateCustomObjectMutation = { createCustomObject: { uid: string } };

export const CreateCustomObjectDocument = gql`
    mutation CreateCustomObject($model: CustomObjectCreationModelInput!) {
  createCustomObject(model: $model) {
    uid
  }
}
    ` as unknown as DocumentNode<CreateCustomObjectMutation, CreateCustomObjectMutationVariables>;
